// * landing component data
export const homeObjOne = {
  headline: "کتاب های خود را به اشتراک بگذارید",
  description:
    " وبسایتی برای علاقه مندان به کتاب خوانی, جهت معرفی و به اشتراک گذاشتن انواع کتاب های فیزیکی در ژانر های گوناگون ... ",
  imgStart: "",
  img: require("./images/3.png").default,
  alt: "کتابخانه",
  start: "",
};
//  * Info component data
export const homeObjTwo = {
  headline: "رایگان کتاب بخوانید",
  description:
    "شما میتوانید کتاب مورد نظر خود را به راحتی در آرشیو ما جست و جو کنید و پس از انتخاب به رایگان آن را دریافت کنید و در صورتی که محصول مورد نظر شما در آرشیو موجود نبود, از کاربران سایت درخواست نمایید",
  imgStart: "start",
  img: require("./images/1.png").default,
  alt: "کتابخانه",
  start: "",
};
export const homeObjThree = {
  headline: "امتیاز کسب کنید",
  description:
    "با مطالعه هر کتاب و ثبت آن در حساب کاربری خود, میتوانید امتیاز کسب کنید و از امتیاز خود برای خرید در معتبر ترین فروشگاه های اینترنتی ایران استفاده کنید",
  imgStart: "start",
  img: require("./images/5.png").default,
  alt: "کتاب ها",
  start: "",
};
// * Carousel component data
export const homeObjFour = {
  headline: "همین حالا شروع کنید",
  description:
    "همین حالا با ساخت حساب کاربری میتوانید کتاب های خود را به اشتراک بگذارید و یا کتاب دیگران را به اشتراک بگیرید. همچنین میتوانید از دیگر مزایای ویژه مشترکین سایت بهره مند شوید",
  imgStart: "start",
  img: require("./images/4.png").default,
  alt: "کتاب ها",
  start: "",
};
// * Carousel component data
export const homeProducts = [
  {
    id: 1,
    image: require("./Product-Images/1.jpg").default,
    name: "خوابگرد قاتل",
    category: "جنایی",
    desc: "«خوابگردِ قاتل» در عین‌حال‌که از نظرِ داستانی اثری مستقل به شمار می‌آید، دومین کتاب از مجموعه‌ی «امارت شر» است که در همان سرزمین و فضای داستانی تحریر شده است. این‌بار نیز شمس باید با قاتلی که با جماعتِ صوفیانِ نالی در ارتباط است، مواجه ‌شود.",
  },
  {
    id: 2,
    image: require("./Product-Images/2.jpg").default,
    name: "فرزندم پاندا",
    category: "وحشت",
    desc: "فرزندم پاندا از ۲۱ داستان کوتاه تشکیل شده است. بیشتر داستانها فضای فراواقعگرا دارند و قانون یا قوانینی از جهان را نقض می کنند و سپس در منطق درون آن داستان، ماجرا ادامه می یابد.نثر داستان ساده است و در بعضی جاها به طنز پهلو می زند. داستانها معمولا خیلی گسترده نشده اند و بار زیادی بر دوش تخیل خواننده است",
  },
  {
    id: 3,
    image: require("./Product-Images/3.jpg").default,
    name: "قرن شوروی",
    category: "تاریخی",
    desc: "احتمالا هیچ مورخ غربی دیگری که درباره ی اتحاد شوروی کار کرده است نمی تواند به اندازه ی موشه لووین ترکیبی از تجربه ی شخصی زندگی با روس ها از زمان استالین به عنوان سرباز جوان زمان جنگ تا دوران پساکمونیستی را با چنین آشنایی عمیق با آرشیو ها و مطالب مروبط به عصر شوروی ارائه کند.",
  },
  {
    id: 4,
    image: require("./Product-Images/4.jpg").default,
    name: "سیلمز لات",
    category: "وحشت",
    desc: "سیلمز لات رمانی ترسناک از نویسنده ی آمریکایی استفان کینگ است که در سال 1975 نوشته شده است. این دومین رمان منتشر شده ی او بود. در این داستان نویسنده ای به نام بن میرس حضور دارد که به شهر لوطن اورشلیم (یا به طور خلاصه سیلمز لات) در ماین ، جایی که از پنج تا نه سالگی در آنجا زندگی می کرد ، بازمی گردد ، اما متوجه می شود که ساکنان آن جا در حال تبدیل شدن به خون آشام هستند.",
  },
  {
    id: 5,
    image: require("./Product-Images/5.jpg").default,
    name: "آقای مرسدس",
    category: "داستانی",
    desc: "در رقابتی دلهره آور با زمان، سه تن از قهرمانان آثار خلق شده توسط استفن کینگ سعی دارند جلوی قاتلی را بگیرند که قصد نابودی هزاران نفر را دارد. آقای مرسدس یک دستاورد غنی، تکان دهنده و بسیار خواندنی برای مردی است که می تواند در هر ژانری که بخواهد داستان بنویسد.",
  },
  {
    id: 6,
    image: require("./Product-Images/7.jpg").default,
    name: "دراکولا",
    category: "وحشت",
    desc: "جاناتان هارکر به نمایندگی از شرکت وکلای اقتصادی، به منظور نهایی کردن قراردادی با نجیب زاده ای از ترنسیلوانیا به نام کنت دراکولا به کوه های کارپات سفر می کند. اما او هیچ نمی داند که با سفر به این منطقه، تمام چیزهای باارزش زندگی اش در خطری مرگبار قرار خواهد گرفت",
  },
];
